/**
 * DeleteConfirmModal - Modal zur Bestätigung des Löschens
 */
import React, { useEffect, useRef } from 'react';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title = 'Delete block', message = 'Do you really want to delete this block? This action cannot be undone.' }) => {
    const confirmButtonRef = useRef(null);
    const t = (key, fallback, params = {}) => {
        if (window.i18n && typeof window.i18n.t === 'function') {
            return window.i18n.t(key, params);
        }
        return fallback;
    };

    // Fokussiere Bestätigungs-Button beim Öffnen
    useEffect(() => {
        if (isOpen && confirmButtonRef.current) {
            // Kurze Verzögerung, damit Modal gerendert ist
            setTimeout(() => {
                confirmButtonRef.current.focus();
            }, 100);
        }
    }, [isOpen]);

    // Keyboard-Handling
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            } else if (e.key === 'Enter' && e.target === confirmButtonRef.current) {
                onConfirm();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose, onConfirm]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button 
                        className="modal-close" 
                        onClick={onClose} 
                        aria-label={t('common.close', 'Schließen')}
                    >
                        ×
                    </button>
                </div>

                <div className="modal-body">
                    <div className="delete-confirm-icon">⚠️</div>
                    <p className="delete-confirm-message">{message}</p>
                </div>

                <div className="modal-footer">
                    <button 
                        className="btn btn-secondary" 
                        onClick={onClose}
                    >
                        {t('common.cancel', 'Abbrechen')}
                    </button>
                    <button 
                        ref={confirmButtonRef}
                        className="btn btn-danger" 
                        onClick={onConfirm}
                        autoFocus
                    >
                        {t('common.delete', 'Löschen')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
